import React, { memo, useState, useMemo } from "react";
import "./styles.scss";
import { Toggleup, Toggledown } from "Res/icons";
import CloseButton from "Components/CloseButton";
import ModelNew from "Components/Model/ModelNew";
import Button from "Components/Common/Button";
import SaveAltIcon from '@mui/icons-material/SaveAlt';

const ServicesDetails = ({ translate, openModel, setOpenModel, servicesDetailsData }) => {
  const details = servicesDetailsData?.content?.categoryDetails;
  const faqs = servicesDetailsData?.content?.faq || [];

  const [selectedCategory, setSelectedCategory] = useState(null);

  const toggleAction = (index) =>
    setSelectedCategory(selectedCategory === index ? null : index);

  const maxi = useMemo(() => {
    const val = details?.option?.maxi;
    return val ? `${val}`.replace(/[()]/g, "").split(":") : null;
  }, [details]);

  const translateText = (key) =>
    key && translate?.[key.toLowerCase()] ? translate[key.toLowerCase()] : key;

  const dataBlock = useMemo(() => (
    faqs.map((item, index) => (
      <div
        key={`mundo__details${index}`}
        className={`sidebar__accordion__section py-1 ${selectedCategory === index ? "active" : ""}`}
      >
        <div className="flex parent md-pb-3 gap-4">
          <div className="toggle__arrow flex middle" onClick={() => toggleAction(index)}>
            {selectedCategory === index ? <Toggleup role="presentation"  /> : <Toggledown role="presentation" />}
          </div>
          <p className="flex-1 pr-3 fw-700 pointer" onClick={() => toggleAction(index)}>
            {item?.faq_title}
          </p>
        </div>
        {selectedCategory === index && (
          <div className="answers flex pb-1 pl-8">
            <p dangerouslySetInnerHTML={{ __html: item?.faq_detail_description }} />
          </div>
        )}
      </div>
    ))
  ), [faqs, selectedCategory]);

  const renderDetailsContent = () => (
    <>
      {details?.category_name && (
        <div className="sidebar__heading pb-3 mb-3 flex col start gap-4 sm-flex sm-row sm-middle">
          <h1 className="fw-700">
            {translateText(details.category_name)}
          </h1>
        </div>
      )}

      {details?.category_description && (
        <div className="sidebar__content">
          <p
            className="mb-4"
            dangerouslySetInnerHTML={{ __html: details.category_description }}
          />
        </div>
      )}
    </>
  );

  return (
    <ModelNew
      from="right"
      hideScroll={false}
      zindex={11}
      open={openModel}
      shadow
      setOpen={setOpenModel}
      className="mondu__payment__sidebar"
    >
      <div
        className="sidebar__details w-full h-full p-5 xl-px-7 xl-pt-10 xl-pb-7 overflow-hidden overflow-y-auto"
        style={{ fontSize: 15, lineHeight: "30px" }}
      >
        <div className="relative">
          <div className="closeButton absolute top-0 right-0">
            <CloseButton onClickFunction={() => setOpenModel(false)} />
          </div>
        </div>

        <div className="flex col h-full">
          {/* {(details?.category_name || details?.category_description) && (
            <div className="flex col sidebar__contents mb-5 md-mb-8 pt-8">
              {renderDetailsContent()}
            </div>
          )} */}

          {details?.option?.img && (
            <div className="py-4">
              <div className="relative" style={{ height: 400 }}>
                <img
                  src={details.option.img}
                  alt={details?.option?.position ?? "img"}
                  title={details?.option?.position ?? "img"}
                  className="image-contain absolute w-full h-full"
                  style={{ position: "absolute",width:"100%",height:"100%", top: "15px" }}
                />
              </div>
            </div>
          )}

          {details?.option?.position && (
            <div className="py-4">
              <h3 className="fw-700">Drukmethode</h3>
              <p>{translateText(details.option.position)}</p>
            </div>
          )}

          {details?.option?.positionVal && (
            <div className="py-4">
              <h3 className="fw-700">Drukpositie</h3>
              <p>{translateText(details.option.positionVal)}</p>
            </div>
          )}

          {maxi?.length && (
            <div className="py-4">
              <h3 className="fw-700 capital">{maxi[0]}</h3>
              {maxi[1] && <p>{maxi[1]}</p>}
            </div>
          )}

          {details?.option?.downloadUrl && (
            <div className="py-4">
              <h3 className="fw-700">Template</h3>
              <div className="pt-2">
                <Button
                  variant="outlined"
                  style={{ lineHeight: "24px" }}
                  className="sm py-2 px-7 r-9 primary flex gap-2"
                  onClick={() => window.open(details.option.downloadUrl, "_blank")}
                >
                  <SaveAltIcon /> Downloaden
                </Button>
              </div>
            </div>
          )}

          {!details?.hideVragen && faqs.length > 0 && (
            <div className="sidebar__accordion pt-4 pb-5">
              {openModel && <h1 className="fw-700 texthidecontent">Veelgestelde vragen</h1>}
              {dataBlock}
            </div>
          )}
        </div>
      </div>
    </ModelNew>
  );
};

export default memo(ServicesDetails);
